(function (Drupal) {
    Drupal.behaviors.sofiaScript = {
      attach: function (context, settings) {
        if (document.querySelector('script[src="https://cariai.com/web/wtag?key=cVhlaTdqekZaZkkyL1VZSTRjVjdZMFI0b2hkLzVVMXhmM0xsaDNxWmVScmxQdGNUVWlNcExPVnlsdDNDb2podzFyWEFyblpaWmJmeQ=="]')) {
          return;
        }
        
        var scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.src = "https://cariai.com/web/wtag?key=cVhlaTdqekZaZkkyL1VZSTRjVjdZMFI0b2hkLzVVMXhmM0xsaDNxWmVScmxQdGNUVWlNcExPVnlsdDNDb2podzFyWEFyblpaWmJmeQ==";
        document.head.appendChild(scriptElement);
      }
    };
})(Drupal);
  